import Title from "./Title";
import Balance from "./Balance";

const Header = () => {
	return (
		<>
			<Title />
			<Balance />
		</>
	)
}

export default Header;